import { api } from '@/store';
import recaptcha from '@/plugins/recaptcha';

export default async () => api.post({ url: '/sbidConnect', data: { recaptcha: await recaptcha('sbidConnect') } });
